import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                videolink: 'videoLinkClick'
            }
        }

        this.container = this.$('container')
        this.prev = this.$('prev')
        this.next = this.$('next')
    }

    init() {
        this.swiper = new Swiper(this.container, {
            speed: 800,
            loop: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            grabCursor: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: this.next,
                prevEl: this.prev
            }
        })
    }

    videoLinkClick(e) {
        e.preventDefault()

        const el = e.currentTarget
        const id = this.getData('id', el)
        const host = this.getData('host', el)

        this.call('openVideo', { id, host }, 'Videomodal')
    }

    destroy() {
        this.swiper.destroy()
    }
}
